import ExportWorkflow from '../../../../components/workflows/general/export-workflow';

angular
    .module('festzelt-os.modules.messages')
    .factory('exportMessages', [
            '$injector',
            ($injector) => new ExportWorkflow(
                'messages',
                $injector.get('Alert'),
                $injector.get('$http'),
                $injector.get('$uibModal'),
                $injector.get('$translate'),
                {
                    excel: 'Excel',
                    csv: 'CSV',
                }
            )
        ]
    );



// WEBPACK FOOTER //
// ./src/app/modules/messages/workflows/list/export.js